import { render, staticRenderFns } from "./EditStationPopup.vue?vue&type=template&id=84c84c50&"
import script from "./EditStationPopup.vue?vue&type=script&lang=js&"
export * from "./EditStationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports